import { Box, Typography, Button } from '@mui/material';

type QuestionStepProps = {
    question: string;
    options: { label: string; value: string }[];
    selected: string[];
    onSelect: (value: string) => void;
    step: number;
};

export const QuestionStep = ({ question, options, selected, onSelect, step }: QuestionStepProps) => {
    return (
        <Box>
            <Typography
                variant="h6"
                sx={{ mb: 1, mt: 7, fontWeight: '600', textAlign: 'center' }}
            >
                {question}
            </Typography>

            <Typography
                variant="body2"
                sx={{ mb: 6, fontWeight: '300', textAlign: 'center', visibility: step === 0 ? 'hidden' : 'visible' }}
            >
                You may choose more than one answer.
            </Typography>


            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                {options.map((option) => {
                    const isSelected = selected.includes(option.value);
                    return (
                        <Button
                            key={option.value}
                            variant="outlined"
                            onClick={() => onSelect(option.value)}
                            sx={{
                                padding: 1,
                                fontWeight: '400',
                                backgroundColor: isSelected ? 'primary.main' : 'transparent',
                                color: isSelected ? 'white' : 'inherit',
                                borderColor: isSelected ? 'primary.main' : 'grey.400',
                                '&:hover': {
                                    borderColor: 'primary.main',
                                },
                            }}
                        >
                            {option.label}
                        </Button>
                    );
                })}
            </Box>
        </Box>
    );
};